import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import Popper from '@material-ui/core/Popper'
import { Form } from 'react-bootstrap'
import { MuiThemeProvider } from '@material-ui/core'
import { autocompleteTheme } from 'designer/component/system/themes/elementTheme'

const TreatmentAutocomplete = ({
  controlId,
  label,
  options,
  getOptionLabel,
  inputValue,
  loading,
  menuMinWidth,
  menuPlacement = 'bottom-start',
  disabled,
  onChange,
  onInputChange,
}) => {
  const PopperComponent = menuMinWidth
    ? (props) => (
        <Popper
          {...props}
          style={{
            ...props.style,
            minWidth: menuMinWidth,
          }}
          placement={menuPlacement}
        />
      )
    : undefined

  return (
    <Form.Group className="mb-3" controlId={controlId}>
      <Form.Label>{label}</Form.Label>
      <MuiThemeProvider theme={autocompleteTheme}>
        <Autocomplete
          freeSolo
          PopperComponent={PopperComponent}
          options={options}
          getOptionLabel={getOptionLabel}
          inputValue={inputValue}
          loading={loading}
          disabled={disabled}
          onChange={onChange}
          onInputChange={onInputChange}
          renderInput={(params) => (
            <TextField {...params} fullWidth variant="outlined" size="small" />
          )}
        />
      </MuiThemeProvider>
    </Form.Group>
  )
}


export default TreatmentAutocomplete
